import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import UserService from "@/services/user.service";
import { AxiosError } from "axios";
import { DashboardUserDto } from "@/types/user.type";

@Module({ namespaced: true })
class SupportDashboardModule extends VuexModule {
  users: DashboardUserDto[] = [];

  @Action({ rawError: true })
  async getAll(): Promise<void> {
    try {
      const users = await UserService.getAllAsync();
      this.context.commit("updateField", {
        path: "users",
        value: users
      });
    } catch (e: unknown) {
      const errorMessage = (e as AxiosError).response?.data.message;
      this.context.commit("updateField", {
        path: "errorMessage",
        value: errorMessage
      });
    }
  }
}

SupportDashboardModule.getters = { getField };
SupportDashboardModule.mutations = { updateField };

export default SupportDashboardModule;